import {
    GET_CLIENT_OVERVIEW,
    GET_DOMAIN_PROGRESS,
    GET_GOALS_PROGRESS,
    GET_GOAL_DRILLDOWN,
    GET_GOAL_DRILLDOWN_TARGETS,
    RESET_GOAL_DRILLDOWN,
    RESET_CLINICAL_ANALYTICS,
} from './clinicalAnalytics.types';

/** Overview */
export const getClientOverview = (clientId) => ({
    type: GET_CLIENT_OVERVIEW,
    payload: { clientId },
});

/** Domain Progress */
export const getDomainProgress = (clientId, params) => ({
    type: GET_DOMAIN_PROGRESS,
    payload: { clientId, params },
});

/** Goals Progress */
export const getGoalsProgress = (clientId, params) => ({
    type: GET_GOALS_PROGRESS,
    payload: { clientId, params },
});

/** Goal Drilldown */
export const getGoalDrilldown = (clientId, goalId, params) => ({
    type: GET_GOAL_DRILLDOWN,
    payload: { clientId, goalId, params },
});

/** Goal Drilldown — targets only (used by the single-target chart modal,
 * opened from inside a goal's Targets tab — no need for the summary half). */
export const getGoalDrilldownTargets = (clientId, goalId, params) => ({
    type: GET_GOAL_DRILLDOWN_TARGETS,
    payload: { clientId, goalId, params },
});

/** Reset */
export const resetClinicalAnalytics = () => ({
    type: RESET_CLINICAL_ANALYTICS,
});

export const resetGoalDrilldown = () => ({
    type: RESET_GOAL_DRILLDOWN,
});
